import { HeaderSplitCell } from "../../components/HeaderSplitCell/HeaderSplitCell";

/* istanbul ignore next */
export const HeaderMaps: { [key: string]: Function } = {
  damagedQuantity: (
    headerItem: any,
    { handleSort, getSortIcon }: { handleSort: any; getSortIcon: any }
  ) => {
    return (
      <HeaderSplitCell
        headerItem={headerItem}
        getSortIcon={getSortIcon}
        handleSort={handleSort}
      />
    );
  },
  over: (
    headerItem: any,
    { handleSort, getSortIcon }: { handleSort: any; getSortIcon: any }
  ) => (
    <HeaderSplitCell
      headerItem={headerItem}
      handleSort={handleSort}
      getSortIcon={getSortIcon}
    />
  ),
  short: (
    headerItem: any,
    { handleSort, getSortIcon }: { handleSort: any; getSortIcon: any }
  ) => (
    <HeaderSplitCell
      headerItem={headerItem}
      handleSort={handleSort}
      getSortIcon={getSortIcon}
    />
  )
};
